import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';

import { generalHelpers } from '../../helpers';
import { useMembership, useUser } from '../../hooks/users';
import PaymentPage from '../User/PaymentPage';

interface Props {
  featureTitle: string;
  delayPopup?: boolean;
  onHide?: () => void;
}

const FeatureRequiresVIPAlert: React.FC<Props> = ({
  featureTitle,
  delayPopup,
  onHide,
}) => {
  const user = useUser();
  const hasMembership = useMembership();
  const [show, setShow] = useState(!hasMembership && !delayPopup);
  const { t } = useTranslation();

  useEffect(() => {
    if (delayPopup && !hasMembership) {
      const timeout = window.setTimeout(() => {
        setShow(true);
      }, 2000);
      return () => {
        window.clearTimeout(timeout);
      };
    } else {
      return generalHelpers.noop;
    }
  }, [delayPopup, hasMembership]);

  return (
    // bootstrap modal has z-index 1050
    <Modal
      style={{ zIndex: 1051 }}
      show={show}
      size="xl"
      centered
      onHide={() => {
        onHide && onHide();
        setShow(false);
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>{t('feature-requires-vip')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {t('you-need-to-pay-to-unlock')}
        <strong>{featureTitle}</strong>.
        <hr />
        {user && <PaymentPage />}
      </Modal.Body>
    </Modal>
  );
};

export default FeatureRequiresVIPAlert;
